import { useQuery } from '@tanstack/react-query'
import { isDemoSession } from '@/auth/oidc'
import { keys } from '@/api/hooks/shared/keys'
import {
  demoSuggestUsernames,
  hierarchySearchLive,
  suggestHierarchyAggregate,
} from '@/api/map/hierarchySearch'

/**
 * Aggregate Hierarchy Search autocomplete — same Lab endpoint as results,
 * string `filter` = prefix match under the group's memberList trees.
 */
export function useSearchHierarchyNew(
  filter: string,
  enabled: boolean,
  opts: { prefetchOnEmpty?: boolean } = {},
) {
  const trimmed = filter.trim()
  const allowEmpty = opts.prefetchOnEmpty ?? false
  const canRun = enabled && (allowEmpty || trimmed.length > 0)

  return useQuery({
    queryKey: keys.searchHierarchyNew({ filter: trimmed }),
    enabled: canRun,
    queryFn: async () => {
      if (!hierarchySearchLive() || isDemoSession()) {
        return demoSuggestUsernames(trimmed)
      }
      return suggestHierarchyAggregate(trimmed)
    },
  })
}
